import { render } from "./TestView.vue?vue&type=template&id=1e008633&scoped=true"
import script from "./TestView.vue?vue&type=script&lang=js"
export * from "./TestView.vue?vue&type=script&lang=js"

import "./TestView.vue?vue&type=style&index=0&id=1e008633&scoped=true&lang=css"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e008633"]])

export default __exports__